import React from "react";
import {
  Timeline as SaasTimeline,
  TimelineProps as SaasTimelineProps,
} from "@saas-ui/react";
import { SystemStyleObject } from "@chakra-ui/react";

export type TimelineProps = SaasTimelineProps;

const collapsedSpacerSx: SystemStyleObject = {
  flex: 0,
  minH: 0,
};

const itemIconAlignSx: SystemStyleObject = {
  "& .sui-timeline__item[iconalign='top']": {
    alignItems: "stretch",
  },
  "& .sui-timeline__item[iconalign='top'] .sui-timeline__separator": {
    alignSelf: "stretch",
    justifyContent: "flex-start",
    transform: "translateY(-3px)",
  },
  "& .sui-timeline__item[iconalign='top'] .sui-timeline__separator::before":
    collapsedSpacerSx,
  "& .sui-timeline__item[iconalign='top'] .sui-timeline__track:first-of-type":
    collapsedSpacerSx,
  "& .sui-timeline__item[iconalign='bottom']": {
    alignItems: "stretch",
  },
  "& .sui-timeline__item[iconalign='bottom'] .sui-timeline__separator": {
    alignSelf: "flex-end",
    justifyContent: "flex-end",
    transform: "translateY(3px)",
  },
  "& .sui-timeline__item[iconalign='bottom'] .sui-timeline__separator::after":
    collapsedSpacerSx,
  "& .sui-timeline__item[iconalign='bottom'] .sui-timeline__track:last-of-type":
    collapsedSpacerSx,
};

export const Timeline = ({ sx, ...rest }: TimelineProps) => {
  return <SaasTimeline sx={{ ...itemIconAlignSx, ...sx }} {...rest} />;
};

Timeline.displayName = "Timeline";
